module.exports = __webpack_public_path__ + "img/icon-addr@2x.dda6fea3.png";